import { useSelector } from 'react-redux';
import { CustomProvider, DatePicker } from 'rsuite';
import 'rsuite/Button/styles/index.css';
import DateTimePickerProps from '../../Interfaces/Props/DateTimePickerProps';
import { IRootState } from '../../Storage/Redux/store';

const DateTimePicker = (props: DateTimePickerProps) => {
  const theme = useSelector((state: IRootState) => state.themeConfig.isDarkMode)
    ? 'dark'
    : 'light';

  return (
    <div className={props.className}>
      {props.label}
      <CustomProvider theme={theme}>
        <DatePicker
          value={!!props.value ? new Date(props.value) : undefined}
          style={{ width: '100%' }}
          placeholder={props.placeholder}
          format={props.format}
          showMeridiem={!!props.showMeridian}
          name={props.name}
          onChange={props.onChange}
          onSelect={props.onSelect}
          onOk={props.onSave}
          onClean={props.onReset}
          size={props.size}
          shouldDisableDate={props.disableDates}
          disabled={props.disable}
          cleanable={props.clearable ?? false}
          placement={props.placement}
        />
      </CustomProvider>
    </div>
  );
};

export default DateTimePicker;
